import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import TextField from '../../elements/form/TextField';
import DateField from '../../elements/form/DateField';
import moment from 'moment';
import { clearUpdatedAcademicSession, updateAcademicSession } from '../../../store/actions/academicSessionsActions';
import { Switch } from '@headlessui/react'

const EditAcademicSession = ({session, reload, closeFunction}) => {
    const dispatch = useDispatch()
    const sessionsSelector = useSelector(state => state.academicSessions)

    const [sessionPayload, setSessionPayload] = useState(session || {});
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        if(sessionsSelector.updatedAcademicSession !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'academic session updated successfully!'
            })
            dispatch(clearUpdatedAcademicSession())
            reload()
            setTimeout(() => {
                closeFunction()
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionsSelector.updatedAcademicSession, dispatch, closeFunction]);

    const validateForm = () => {
        let errors = {}
        if(!sessionPayload.name || sessionPayload.name === '') {
            errors.name = true
        }
        if(!sessionPayload.startDate || sessionPayload.startDate === '') {
            errors.startDate = true
        }
        if(!sessionPayload.endDate || sessionPayload.endDate === '') {
            errors.endDate = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushSession = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            // dispatch(updateAcademicSession(session._id, {...sessionPayload, ...{startDate: new Date(sessionPayload.startDate), endDate: new Date(sessionPayload.endDate)}}))
            dispatch(updateAcademicSession(session._id, sessionPayload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                {/* <p className='text-sm'>Provide the following information to create a new academic session</p> */}
            </div>
            <div className='mt-4'>
                <TextField
                    inputLabel="Session name/title" 
                    fieldId="fee-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={sessionPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setSessionPayload({...sessionPayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <DateField
                    inputLabel="Start Date" 
                    fieldId="start-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(sessionPayload.startDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.startDate} 
                    returnFieldValue={(value)=>{
                        setSessionPayload({...sessionPayload, ...{startDate: new Date(value)}})
                    }}
                />
            </div>

            <div className='my-2 w-full'>
                <DateField
                    inputLabel="End Date" 
                    fieldId="end-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(sessionPayload.endDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.endDate} 
                    returnFieldValue={(value)=>{
                        setSessionPayload({...sessionPayload, ...{endDate: new Date(value)}})
                    }}
                />
            </div>

            <div className="w-full flex justify-between gap-x-4 mt-6 border-secondary border-opacity-50">
                <div className='w-10/12'>
                    <h3 className="block text-sm text-gray-700 font-space-grotesk font-semibold">Currently Running</h3>
                    <p className="text-xs leading-tight text-gray-500 font-sofia-pro">Flip this switch if this academic session is currently running.</p>
                </div>
                <div className='w-2/12 flex flex-row-reverse pt-2'>
                    <Switch
                        checked={sessionPayload.current}
                        onChange={()=>{setSessionPayload({...sessionPayload, current: !sessionPayload.current})}}
                        className={`${
                            sessionPayload.current ? 'bg-accent' : 'bg-gray-400'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        <span className="sr-only">Requires fee</span>
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                                sessionPayload.current ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                            } inline-block w-3 h-3 transform rounded-full`}
                        />
                    </Switch>
                </div>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update session`}
                    buttonAction={()=>{pushSession()}}
                    processing={sessionsSelector.creatingAcademicSession}
                 />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default EditAcademicSession